import { getApiUrl } from "@/utils/api";
import { useState, useEffect } from "react";
import axios from "axios";

const API = getApiUrl();

// Cache for content to avoid refetching
const contentCache = {};

export const usePageContent = (pageId) => {
  const [content, setContent] = useState(contentCache[pageId] || {});
  const [loading, setLoading] = useState(!contentCache[pageId]);

  useEffect(() => {
    if (contentCache[pageId]) {
      setContent(contentCache[pageId]);
      setLoading(false);
      return;
    }

    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/content/${pageId}`);
        contentCache[pageId] = response.data.content || {};
        setContent(contentCache[pageId]);
      } catch (error) {
        console.error(`Failed to fetch content for ${pageId}:`, error);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [pageId]);

  // Helper to get content with fallback
  const get = (sectionId, fallback = "") => {
    return content[sectionId] || fallback;
  };

  return { content, loading, get };
};

export default usePageContent;
